import { FC } from 'react';

import { Button, ButtonStyles } from '@silverfort/sf-components';
import { ROLES } from '@silverfort-nodelibs/common/utils/consts';

import useSendEnrollmentRequestPopup from './hooks/useSendEnrollmentRequestPopup';
import { isUserPermitted } from '../../../../TowerMenu/TowerMenuUtils';
import { SystemData } from '../../types/SystemData';
import { UserSession } from '../../../../api';

interface Props {
    buttonLabel?: string;
    userSession?: UserSession;
    systemData?: SystemData;
}

const SendEnrollmentRequest: FC<Props> = ({ buttonLabel = 'Send enrollment request', userSession, systemData }) => {
    const { openSendEnrollmentRequestPopup } = useSendEnrollmentRequestPopup({ systemData, userSession });

    return (
        <Button
            buttonStyle={ButtonStyles.Primary}
            text={buttonLabel}
            onClick={openSendEnrollmentRequestPopup}
            disabled={
                !isUserPermitted(userSession, 'sendEnrollmentEmail', ROLES.EDITOR.value) &&
                !isUserPermitted(userSession, 'sendEnrollmentEmailToAllUnpaired', ROLES.EDITOR.value)
            }
        />
    );
};

export default SendEnrollmentRequest;
